export const ARIA_LABEL = {
  FRAME_SLIDER: 'v-frame-slider',
  FRAME_SLIDER_THUMB: 'v-frame-slider-thumb',
} as const;

export enum FRAME_SLIDER_SCALE {
  SCALE_1 = 1,
  SCALE_2 = 2,
  SCALE_3 = 3,
  SCALE_4 = 4,
  SCALE_5 = 5,
  SCALE_6 = 6,
}

export const FRAME_SLIDER_SCALE_CONFIG = {
  [FRAME_SLIDER_SCALE.SCALE_1]: {
    step: 1,
    threshold: 10,
  },
  [FRAME_SLIDER_SCALE.SCALE_2]: {
    step: 5,
    threshold: 50,
  },
  [FRAME_SLIDER_SCALE.SCALE_3]: {
    step: 10,
    threshold: 100,
  },
  [FRAME_SLIDER_SCALE.SCALE_4]: {
    step: 50,
    threshold: 500,
  },
  [FRAME_SLIDER_SCALE.SCALE_5]: {
    step: 100,
    threshold: 1000,
  },
  [FRAME_SLIDER_SCALE.SCALE_6]: {
    step: 1000,
    threshold: 10000,
  },
} as const;

export const MAX_FRAME = 999999;
export const MIN_FRAME = 1;

// Virtual scroll 설정
export const VISIBLE_MARKER_COUNT = 50;
